import siteSearchGroup from '@/components/search-group.vue'
import { inviteMacademic } from '@/api/macademic'
import { mapGetters, mapActions } from 'vuex'
import file from '@/api/file'
import { ACADEMIC_STATUS } from '@/utils/dict'
import SendEmail from '../../editorial-office/manuscripts/dialog/send-email.dialog'

const columns = [
  {
    title: '',
    enTitle: '',
    width: 80,
    dataIndex: 'cover',
    slot: 'img'
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 120,
    dataIndex: 'manuscriptId',
    slot: 'manuscriptNo'
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 280,
    dataIndex: 'title',
    slot: 'title'
  },
  {
    title: '',
    enTitle: 'Special Issue',
    width: 160,
    dataIndex: 'editor',
    slot: 'special'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 140,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 210,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    siteSearchGroup,
    // abstractModal,
    SendEmail
  },
  data() {
    return {
      academicStatus: ACADEMIC_STATUS,
      params: {
        keyword: '',
        // journalId: '',
        status: 'PENDING_DECISION'
      },
      journalList: [],
      count: [],
      titleStatus: {
        PENDING_DECISION: 'Pending Decision',
        COMPLETED_DECISION: 'Completed Decision'
      },
      emptyText: {
        PENDING_DECISION:
          'There is no manuscript pending your decision. Please enjoy your day.',
        COMPLETED_DECISION: `You haven't decided on any manuscript yet.`
      },
      countStatus: {},
      columns,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        showSizeChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      dataSource: [],
      // isVisable: false,
      // abstractDetail: '',

      showSendEmail: false,
      inputData: {},
      isEdit: false
    }
  },
  computed: {
    ...mapGetters({ domain: 'getDomain' })
  },
  async mounted() {
    // await this.getJournalList()
    if (this.$route.query.status) {
      this.params.status = this.$route.query.status
    }
    await this.getList()
  },
  methods: {
    ...mapActions(['updateDomain']),
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    },
    async getCount() {
      this.countStatus = await inviteMacademic.count(this.params)
    },
    async getList(page, size) {
      if (!page) {
        page = 1
      }
      if (!size) {
        size = this.pagination.size
      }

      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: size
      })
      const {
        list,
        pageIndex,
        pageSize,
        total
      } = await inviteMacademic.getList(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
      this.getCount()
    },
    handleClear() {
      this.params.keyword = ''
      // this.params.journalId = ''
      this.getList()
    },
    // async getJournalList() {
    //   this.journalList = await journal.getAll({ released: true })
    //   const flag = this.journalList.some(item => {
    //     if (item.id === localStorage.getItem('opjournalId')) {
    //       this.params.journalId = item.id
    //       return true
    //     }
    //   })
    //   if (!flag) {
    //     this.params.journalId = this.journalList[0] && this.journalList[0].id
    //     localStorage.setItem('opjournalId', this.params.journalId)
    //   }
    // },
    changeJournal(val) {
      this.getList()
      localStorage.setItem('opjournalId', val)
    },
    changeStatus(key) {
      this.params.status = key
      if (this.$route.query.status) {
        this.$router.push('/academic-menu/academic')
      }
      this.getList()
    },
    detail(val) {
      let link = `/academic-menu/academic/detail/${val.decisionType}/${val.id}?manuscriptId=${val.manuscript.id}&sign=${val.sign}&status=${val.status}`
      this.$router.push(link)
    },
    // 提交决策
    commit(val) {
      let link = `/academic-menu/academic/submit/${val.decisionType}/${val.id}?manuscriptId=${val.manuscript.id}&sign=${val.sign}&status=${val.status}`
      this.$router.push(link)
    },
    // 申请延时
    sendEmail(val) {
      this.showSendEmail = true
      this.inputData = {
        reviewerPersonId: val.personId,
        minvitedReviewerId: val.id,
        manuscriptId: val.manuscriptId,
        sign: val.sign,
        journalId: (val.journal && val.journal.id) || val.journalId
      }
    },
    // 关闭弹窗
    cancel() {
      this.isVisable = false
      this.showSendEmail = false
    }
  }
}
